import { useQuery } from 'react-query'
import { BASE_API_URL } from 'constants/env'
import { API_METHODS } from 'constants/api-methods'
import { apiHeaders } from 'utils/api-headers'
import { store } from 'index'
import { handleErrors } from 'utils/handle-errors'
import {
  PaginatedPhysicalPhoneResponse,
  PhoneStatus,
} from 'interfaces/physical-phone'

interface ReceivedPhysicalPhonesParams {
  terminalId?: string
  page?: number
  limit?: number
  name?: string
}

const fetchReceivedPhysicalPhones = async (
  params: ReceivedPhysicalPhonesParams
): Promise<PaginatedPhysicalPhoneResponse> => {
  const searchParams = new URLSearchParams()

  if (params.terminalId) searchParams.append('terminalId', params.terminalId)
  if (params.page)
    searchParams.append(
      'offset',
      ((params.page - 1) * (params.limit || 20)).toString()
    )
  if (params.limit) searchParams.append('limit', params.limit.toString())
  if (params.name) searchParams.append('nameSearch', params.name)

  // Only fetch RECEIVED status devices
  searchParams.append('status', PhoneStatus.RECEIVED)

  let response = await fetch(
    `${BASE_API_URL}/api/v4/phone_number_service/physical_phones?${searchParams.toString()}`,
    {
      method: API_METHODS.GET,
      headers: apiHeaders(store.getState()),
    }
  )
  response = handleErrors(response)
  return response.json()
}

const useReceivedPhysicalPhones = (
  params: ReceivedPhysicalPhonesParams = {}
) => {
  return useQuery(
    ['received-physical-phones', params],
    () => fetchReceivedPhysicalPhones(params),
    {
      enabled: !!params.terminalId,
      staleTime: 30000,
      retry: 2,
    }
  )
}

// Hook to get count of received Physical Phones for a terminal
export const useReceivedPhysicalPhonesCount = (terminalId?: string) => {
  return useQuery(
    ['received-physical-phones-count', terminalId],
    () => fetchReceivedPhysicalPhones({ terminalId, limit: 1 }),
    {
      enabled: !!terminalId,
      staleTime: 30000,
      retry: 2,
      select: (data) => data.pagination.total,
    }
  )
}

export default useReceivedPhysicalPhones
